import React from 'react';
import ArrowsDownUpIcon from 'assets/svg/arrows-down-up.svg';
import SortIcon from 'assets/svg/sort-16.svg';
import ChevronDownIcon from 'assets/svg/chevron-down-20.svg';
import { MarketplaceType } from 'utils/entities';
import ListingSort from 'components/listing-sort';
import { useScreenBreakpoint } from 'consts/breakpoints';

interface SearchListingSortProps {
  marketplace: MarketplaceType;
}

const SearchListingSort: React.FC<SearchListingSortProps> = (props) => {
  const isMobile = useScreenBreakpoint() <= 2;
  const rightIcon = isMobile ? <ArrowsDownUpIcon /> : <SortIcon />;
  const customIcon = isMobile ? undefined : <ChevronDownIcon />;

  return (
    <ListingSort
      {...props}
      noCounter
      rightIcon={rightIcon}
      customIcon={customIcon}
    />
  );
};

export default SearchListingSort;
